import React from 'react';
import ExportComposer from '../export/ExportComposer';

// Riusa il compositore export esistente (esito Tutti/TIM/NON TIM, filtri, aree salvate,
// crea lotto). La selezione arriva dal tab Territorio come selezione iniziale.
export default function TabExport({ initial }) {
  return (
    <div className="card">
      <ExportComposer initial={initial} />
    </div>
  );
}
